module.exports = __webpack_public_path__ + "static/media/node.48919565.png";